module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAAy0lEQVQoFZWQvQ4BQRSFd0QUJBQKlUfQKGSfQUOp8AwSjVLjOUj0CppV8AqeQEJEIlEotvGTkPEd1WQzwp7k27lz95w7kwmClDLW2i6ZPsSebI7eFMZQg5sCG4qGMebF+hG9PEUHFrCEO8gXZvnErpm91IQhlGAPPTxnBq0U8CmiWYQ5hK7BG2DaFdNERqa6fptxd//UqQO6UuHH5Ar/W1ztKK+edURRhy0kVaVxgAG04aETZqBTypDUjkbEIzxZ5QsUuMBamy86uf038Eo1PYUNYgEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/enter.png
// module id = VR+0
// module chunks = 1